
export default function Hero() {
  return (
    <div className="hero" id="hero">
      <h1 className="hero-heading">
        Hi, I am Monir Akhand a Frontend developer from Sweden
      </h1>
    </div>
  );
}
